import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AiFillFunnelPlot } from 'react-icons/ai';
import TFSegment from '../TFSegment';
import { formatShorthand, happeningToday, happeningTomorrow, happeningWeek } from '../../../common/utils';

import '../../../containers/Dashboard/dashboard.css';

const ActiveLoans = ( { title, aid, uid, viewing, contacts, loans, status } ) => {
    const [ actives, setActives ] = useState( [] );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ purposeCount, setPurposeCount ] = useState( [] );
    const [ purposeVol, setPurposeVol ] = useState( [] );
    const [ purposeRev, setPurposeRev ] = useState( [] );
    const [ hapToday, setHapToday ] = useState( [] );
    const [ hapTomorrow, setHapTomorrow ] = useState( [] );
    const [ hapWeek, setHapWeek ] = useState( [] );
    
    const actions = [
        // { icon: <CallIcon />, label: 'Log a Call', type: 'log-call' },
        // { icon: <EmailIcon />, label: 'Send Email', type: 'email', dropdown: true },
        // { icon: <TextsmsIcon />, label: 'Send Txt', type: 'txt', dropdown: true },
        // { icon: <ScheduleIcon />, label: 'Remind Me Tomorrow', type: 'reschedule', dropdown: true },
    ];

    useEffect( () => {
        const list = [];

        const stats = status?.filter( f => f.queue === 'active' ).map( m => m.value );
        Object.keys( loans ).forEach( lid => {
            const l = loans[lid];
            if ( l && viewing.includes( l.aid ) ) {
                if ( stats.includes( l.status ) ) {
                    list.push( lid );
                }
            }
        } );

        setActives( list );
    }, [ loans, status, viewing ] );

    useEffect( () => {
        let v = 0;
        let pcount = {};
        let pvol = {};
        let prev = {};
        let todayList = [];
        let tomorrowList = [];
        let weekList = [];

        const today = new Date();
        today.setHours( 12, 0, 0, 0 );

        actives.forEach( lid => {
            const l = loans[lid];
            if ( !l ) {
                return;
            }
            if ( !viewing.includes( l.aid ) ) {
                return;
            }

            const bor = l.borrowers?.find( f => f.label === 'Primary' );
            const borrowerName = contacts[bor?.cid]?.name;

            let amount = 0;
            if ( l.amount && typeof l.amount === 'string' ) {
                const nonDig = /\D/g;
                const tmp = l.amount.replace( /\.\d+$/, '' ).replace( nonDig, '' );
                amount = ( tmp.length ) ? parseInt( tmp ) : 0;
            } else if ( l.amount > 0 ) {
                amount = l.amount;
            }

            if ( !pcount[l.purpose] ) {
                pcount[l.purpose] = 1;
                pvol[l.purpose] = amount;
                prev[l.purpose] = ( l.rev ) ? l.rev : 0;
            } else {
                pcount[l.purpose]++;
                pvol[l.purpose] += amount;
            }
            v += amount;
            
            // contract

            // lock

            // lock exp
            if ( l.lockExpDate ) {
                const d = new Date( l.lockExpDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-lockexp',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s lock is expiring today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-lockexp',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s lock is expiring tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-lockexp',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s lock is expiring on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }

            // loan cont
            if ( l.loanContDate ) {
                const d = new Date( l.loanContDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-loancont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s loan contingency should be removed today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-loancont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s loan contingency should be removed tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-loancont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s loan contingency should be removed on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }

            // appr cont
            if ( l.appraisalContDate ) {
                const d = new Date( l.appraisalContDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-appcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s appraisal contingency should be removed today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-appcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s appraisal contingency should be removed tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-appcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s appraisal contingency should be removed on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }

            // insp cont
            if ( l.inspectionContDate ) {
                const d = new Date( l.inspectionContDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-inspcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s inspection contingency should be removed today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-inspcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s inspection contingency should be removed tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-inspcont',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + '\'s inspection contingency should be removed on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }

            // signing
            if ( l.signingDate || l.anticipatedSigningDate ) {
                const sd = ( l.signingDate ) ? l.signingDate : l.anticipatedSigningDate;
                const d = new Date( sd + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-signing',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be signing today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-signing',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be signing tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-signing',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be signing on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }

            // close
            if ( l.coeDate ) {
                const d = new Date( l.coeDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be closing today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be closing tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be closing on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            } else if ( l.fundingDate ) {
                const d = new Date( l.fundingDate + 'T12:00:00' );
                d.setHours( 12, 0, 0, 0 );

                if ( happeningToday( today, d ) ) {
                    todayList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be funding today',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningTomorrow( today, d ) ) {
                    tomorrowList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be funding tomorrow',
                        c: contacts[bor?.cid]
                    } );
                } else if ( happeningWeek( today, d ) ) {
                    weekList.push( {
                        id: l.lid + '::tf-coe',
                        oid: l.lid,
                        lid: l.lid,
                        title: l.subjectAddress,
                        sub: borrowerName + ' should be funding on ' + d.toLocaleDateString(),
                        c: contacts[bor?.cid]
                    } );
                }
            }
        } );
        
        setVol( v );
        setPurposeCount( Object.keys( pcount ).map( m => {
            return { name: m, value: pcount[m] };
        } ) );
        setPurposeVol( Object.keys( pvol ).map( m => {
            return { name: m, value: pvol[m] };
        } ) );
        setPurposeRev( Object.keys( prev ).map( m => {
            return { name: m, value: prev[m] };
        } ) );
        setHapToday( todayList );
        setHapTomorrow( tomorrowList );
        setHapWeek( weekList );
    }, [ actives, loans, contacts, viewing ] );


    return (
        <Fragment>
            <Row className='tf-dashboard-section-header mx-2'>
                <Col className='p-2 tf-dashboard-section-header-title'>
                    <AiFillFunnelPlot />
                    <span className='ps-2'>{title}</span>
                </Col>
            </Row>
            <Row className='p-0' style={ { overflowX: 'auto' } }>
                <Col className='p-0'>
                    <TFSegment 
                        chartTitle = {actives.length.toString()}
                        chartSub = 'Loans'
                        chartData = {purposeCount}
                        gridTitle = "Today's Highlights"
                        gridData = {hapToday}
                        gridActions = {actions}
                    />
                </Col>
                <Col className='p-0'>
                    <TFSegment 
                        chartTitle = { '$' + formatShorthand( vol ) }
                        chartSub = 'Volume'
                        chartData = {purposeVol}
                        gridTitle = "Tomorrow's Highlights"
                        gridData = {hapTomorrow}
                        gridActions = {actions}
                    />
                </Col>
                <Col className='p-0'>
                    <TFSegment 
                        chartTitle = { '$' + formatShorthand( rev ) }
                        chartSub = 'Revenue'
                        chartData = {purposeRev}
                        gridTitle = "Next 7 Days of Highlights"
                        gridData = {hapWeek}
                        gridActions = {actions}
                    />
                </Col>
            </Row>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    status: state.user.meta.loan.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( ActiveLoans );